import ContentOverlay from "../components/content_overlay";

function AnnouncementsPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Announcements</h2>}
      text_content={
        <ol style={{ lineHeight: 1.5, textAlign: "left" }}>
          <li>
            XXXIII Annual Conference of the Indian&nbsp;Association for
            Angiosperm Taxonomy (IAAT) will be organized by the Department of
            Botany,&nbsp;St. Joseph's College (Autonomous), Devagiri, Kozhikode,
            Kerala from 21-23 November 2025.-{" "}
            <a href="https://www.iaat.org.in/events_XXXV-Conference-Devagiri.html?t=NEWS">
              https://www.iaat.org.in/events_XXXV-Conference-Devagiri.html?t=NEWS#
            </a>
          </li>
          <br />
          <li>
            Global Congress on Plant Biology and Biotechnology
            (GCPBB).&nbsp;GCPBB&nbsp;will be held on&nbsp;16th Apr
            2025&nbsp;in&nbsp;Thiruvananthapuram, India.{" "}
            <a href="https://irfsr.com/">https://irfsr.com/</a>
          </li>
          <br />
          <li>
            Global Congress on Plant Biology and Biotechnology
            (GCPBB).&nbsp;GCPBB&nbsp;will be held on&nbsp;17th Apr
            2025&nbsp;in&nbsp;Kannur, India.{" "}
            <a href="https://irfsr.com/">https://irfsr.com/</a>
          </li>
          <br />
          <li>
            Global Congress on Plant Biology and Biotechnology
            (GCPBB).&nbsp;GCPBB&nbsp;will be held during&nbsp;20th Apr
            2025&nbsp;in&nbsp;Kollam, India.{" "}
            <a href="https://irfsr.com/">https://irfsr.com/</a>
          </li>
          <br />
          <li>
            International Conference on Environment and Life Science
            (ICELS)&nbsp; will be held on&nbsp;25th Apr
            2025&nbsp;at&nbsp;Thiruvananthapuram, India&nbsp;-{" "}
            <a href="https://sciencefora.org/">https://sciencefora.org/</a>
          </li>
          <br />
          <li>
            International Conference on Chemical, Agricultural, Biological,
            Environment and Life Science (ICCABEL), Thrissur,&nbsp;India during
            2-3 April 2025- <a href="https://gsrd.co/">https://gsrd.co/</a>
          </li>
          <br />
          <li>
            Global Congress on Plant Biology and Biotechnology
            (GCPBB).&nbsp;GCPBB&nbsp;will be held during&nbsp;12th May
            2025&nbsp;in&nbsp;Cochin, India.{" "}
            <a href="https://irfsr.com/">https://irfsr.com/</a>
          </li>
          <br />
          <li>
            Global Congress on Plant Biology and Biotechnology
            (GCPBB).&nbsp;GCPBB&nbsp;will be held during&nbsp;16th May
            2025&nbsp;in&nbsp;Thiruvananthapuram, India.{" "}
            <a href="https://irfsr.com/">https://irfsr.com/</a>
          </li>
          <br />
          <li>
            Global Congress on Plant Biology and Biotechnology
            (GCPBB).&nbsp;GCPBB&nbsp;will be held during&nbsp;20th May
            2025&nbsp;in&nbsp;Kollam, India.{" "}
            <a href="https://irfsr.com/">https://irfsr.com/</a>
          </li>
          <br />
          <li>
            International Conference on Environment and Life Science
            (ICELS)&nbsp; will be held on&nbsp;25th May
            2025&nbsp;at&nbsp;Thiruvananthapuram, India &nbsp;
            <a href="https://sciencefora.org/">https://sciencefora.org/</a>
          </li>
          <br />
          <li>
            International Conference on Environment and Life Science(ICELS),
            will be held at&nbsp;Palakkad, India,&nbsp;on&nbsp;31st May 2025.{" "}
            <a href="https://itrgroup.net/Conference/2194/ICELS/">
              https://itrgroup.net/Conference/2194/ICELS/
            </a>
          </li>
          <br />
          <li>
            5th World Teak Conference 2025: Sustainable Development of the
            Global Teak Sector &ndash; Adapting to Future Markets and
            Environments- will be held at kochi- on 17-20 Sep 2025-{" "}
            <a href="https://www.iufro.org/">https://www.iufro.org/</a>
          </li>
          <br />
          <li>
            International Conference on Ecology, Agriculture and Forestry
            (ICEAF-25)- will be at Kollam &ndash; India on 5th April 2025-{" "}
            <a href="https://nier.in/conf/index.php?id=3333977">
              https://nier.in/conf/index.php?id=3333977
            </a>
          </li>
          <br />
          <li>
            International Conference on Ecology, Agriculture and Forestry
            ICEAF-25, to be held on 3rd May 2025 at Trivandrum-{" "}
            <a href="https://www.sfe.net.in/conf/index.php">
              https://www.sfe.net.in/conf/index.php
            </a>
          </li>
          <br />
          <li>
            International Conference on Forestry Food and Sustainable
            Agriculture(ICFFSA)&nbsp;&nbsp;will be held&nbsp;on&nbsp;26th Mar
            2025 at &nbsp;Ernakulam, India.{" "}
            <a href="http://wrfer.org/">http://wrfer.org/</a>
          </li>
          <br />
          <li>
            National conference on agriculture and food
            sciences(NCAFS)&nbsp;.&nbsp;NCAFS&nbsp;will be held during&nbsp;26th
            Mar 2025&nbsp;in&nbsp;Ernakulam, India{" "}
            <a href="https://nationalconference.org.in/Conference/18072/NCAFS/">
              https://nationalconference.org.in/Conference/18072/NCAFS/
            </a>
          </li>
          <br />
          <li>
            International Conference on Agriculture(ICAG), which will be held
            at&nbsp;Munnar, India,&nbsp;on&nbsp;29th Mar 2025. ICAG is hosted by
            ASAR- India.&nbsp;{" "}
            <a href="http://asar.org.in/Conference/60282/ICAG/">
              http://asar.org.in/Conference/60282/ICAG/
            </a>
          </li>
          <br />
          <li>
            The International Conference on Agriculture, forestry, Biotechnology
            and Food Science(ICAFBFS) will be held in&nbsp;Kottayam, India,
            on&nbsp;31st Mar 2025.{" "}
            <a href="https://scienceglobe.org/Conference/21487/ICAFBFS/">
              https://scienceglobe.org/Conference/21487/ICAFBFS/
            </a>
          </li>
          <br />
          <li>
            International Conference on Environment, Agriculture and
            Biotechnology (ICEABT) will be held in&nbsp;Palakkad, India,
            on&nbsp;01st Apr 2025.{" "}
            <a href="https://academicsconference.com/Conference/56601/ICEABT/">
              https://academicsconference.com/Conference/56601/ICEABT/
            </a>
          </li>
          <br />
          <li>
            International Conference on Agriculture and Horticulture(ICAH). The
            conference will be held at&nbsp;Munnar,
            India&nbsp;on&nbsp;&nbsp;04th Apr 2025.{" "}
            <a href="https://iistem.org/Conference/21034/ICAH/">
              https://iistem.org/Conference/21034/ICAH/
            </a>
          </li>
          <br />
          <li>
            National Conference on Advances in Science, Agriculture,
            Environmental &amp; Biotechnology - NCASAEB&nbsp;will be held
            on&nbsp;06th Apr 2025&nbsp;in&nbsp;Cochin, India.{" "}
            <a href="https://nationalconferences.org/Conference/18411/NCASAEB/">
              https://nationalconferences.org/Conference/18411/NCASAEB/
            </a>
          </li>
          <br />
          <li>
            International Conference on Forestry Food and Sustainable
            Agriculture(ICFFSA)&nbsp;&nbsp;will be held&nbsp;on&nbsp;19th Apr
            2025 at &nbsp;Kozhikode, India.&nbsp;&nbsp;<em>ICFFSA</em>-{" "}
            <a href="http://wrfer.org/">http://wrfer.org/</a>
          </li>
          <br />
          <li>
            International Conference on Plant &amp; Soil Science which is slated
            to held in&nbsp;29th March'2025&nbsp;in&nbsp;Trivandrum, India{" "}
            <a href="https://nier.in/conf/index.php?id=3111704">
              https://nier.in/conf/index.php?id=3111704
            </a>
          </li>
          <br />
          <li>
            International Conference on Ecology IC-E-25-To be held on 7th June
            2025 at Trivandrum.{" "}
            <a href="https://www.sfe.net.in/conf/index.php">
              https://www.sfe.net.in/conf/index.php
            </a>
          </li>
          <br />
        </ol>
      }
    />
  );
}

export default AnnouncementsPage;
